{
    "areYouSure": "Are you sure?",
    "changesMade": "You have made changes since your last save, are you sure you want to cancel those changes?",
    "cancel": "Cancel",
    "ok": "OK"
}